import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./package-view.scss";
import "../service-accordion/service-accordion.scss";

const PackageView = ({ pkg, tax = 0, total = 0 }: any) => {
  if (!pkg) return null;

  return (
    <>
      <h3 className="service-title">Package</h3>

      <div className="accordion-header">
        <span className="name-badge">{pkg.packageName}</span>
      </div>

      <div className="accordion-body">
        <div className="accordion-row even">
          <strong>Services Included</strong>
        </div>

        {pkg.servicesIncluded?.length ? (
          pkg.servicesIncluded.map((item: any, i: number) => (
            <div key={i} className="item-row">
              <CheckCircleIcon className="tick-icon" />
              <span>{item.name}</span>
            </div>
          ))
        ) : (
          <div className="accordion-empty">Services not available</div>
        )}

        <div className="accordion-subtotal">
          <span>Subtotal</span>
          <span>${pkg.price}</span>
        </div>
      </div>
      <div className="summary-section">
        <div className="summary-row">
          <span>Taxes</span>
          <span>${tax}</span>
        </div>

        <div className="summary-row grand-total">
          <span>Total Amount</span>
          <span>${total}</span>
        </div>
      </div>
    </>
  );
};

export default PackageView;
